"use client";
export { default as Select } from "./Select.js";
//# sourceMappingURL=index.js.map